import React from 'react';

import CaretUp from '@/components/commons/icons/CaretUp';
import CaretDown from '@/components/commons/icons/CaretDown';

function Triangle({
    open = false,
}) {
    const styles = {
        width: '1.75em',
        height: '1.75em',
    };
    return (
        <div style={styles} className="bg-contain bg-center text-cirrusWhite">
            {
                open ? <CaretUp className="mx-1 mt-[2px] h-4 w-4" />
                    : <CaretDown className="mx-1 mt-[2px] h-4 w-4" />
            }
        </div>
    );
}

export default Triangle;
